import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import authService from '../services/authService';
import { validateEmail } from '../utils/validation';
import Icon from './Icon';

function ForgotPassword() {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [emailError, setEmailError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setMessage('');
    setIsLoading(true);
    
    const emailValidationError = validateEmail(email);
    if (emailValidationError) {
      setError(emailValidationError);
      setIsLoading(false);
      return;
    }

    try {
      const data = await authService.forgotPassword(email);
      
      // 소셜 로그인 계정인 경우
      if (data.isSocialAccount) {
        const providerNames = { naver: '네이버', kakao: '카카오', google: '구글' };
        const providerName = providerNames[data.provider] || data.provider;
        setError(`${providerName}로 가입한 계정입니다. ${providerName} 로그인을 이용해주세요.`);
      } else {
        setMessage(data.message);
      }
    } catch (error) {
      setError(error.userMessage || '오류가 발생했습니다.');
    } finally {
      setIsLoading(false);
    }
  };

  if (message) {
    return (
      <div className="auth-page">
        <div className="auth-card">
          <div className="auth-header">
            <Icon name="email" size={48} />
          </div>
          
          <h2 className="auth-title">
            이메일 전송 완료
          </h2>
          
          <p className="auth-subtitle auth-message">
            {message}
          </p>
          
          <button
            onClick={() => navigate('/login')}
            className="btn-primary btn-full-width"
          >
            로그인으로 돌아가기
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="auth-page">
      <div className="auth-card">
        <div className="auth-header">
          <h1 className="auth-title"><Icon name="lock" /> 비밀번호 찾기</h1>
          <p className="auth-subtitle">
            가입하신 이메일 주소를 입력해주세요
          </p>
        </div>

        {error && (
          <div className="auth-error">
            {error}
          </div>
        )}

        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="forgot-email">
              이메일 주소
            </label>
            <input
              id="forgot-email"
              type="email"
              value={email}
              onChange={(e) => {
                setEmail(e.target.value);
                const error = validateEmail(e.target.value);
                setEmailError(error);
              }}
              required
              className={emailError ? 'has-error' : ''}
              placeholder="이메일을 입력하세요"
            />
            {emailError && (
              <div className="form-error">
                {emailError}
              </div>
            )}
          </div>

          <button
            type="submit"
            disabled={isLoading}
            className="btn-primary btn-full-width"
          >
            {isLoading ? '전송 중...' : '비밀번호 재설정 링크 전송'}
          </button>

          <div className="auth-footer">
            <button
              type="button"
              onClick={() => navigate('/login')}
              className="btn-secondary btn-full-width"
            >
              로그인으로 돌아가기
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default ForgotPassword;
